import { Container, Stack, styled, Typography } from "@mui/material";
import { animate } from "framer-motion";

import img from "../../../Images/Icon/C4_WWW_Icons_White-Smart-Home-OS.svg";
import img2 from "../../../Images/Icon/C4_WWW_Icons_White_No_Circle_Un_Rmt.svg";
import img3 from "../../../Images/Icon/4sight-white.svg";
import img4 from "../../../Images/Icon/C4_WWW_Icons_White-Home-Security.svg";
import img5 from "../../../Images/Icon/C4_WWW_Icons_White-Home-Theater.svg";
import img6 from "../../../Images/Icon/C4_WWW_Icons_White-Intercom-Anywhere.svg";
import img7 from "../../../Images/Icon/C4_WWW_Icons_White-Multiroom-Audio.svg";
import img8 from "../../../Images/Icon/C4_WWW_Icons_White-Smart-Lighting.svg";
import img9 from "../../../Images/Icon/C4_WWW_Icons_White-Voice-Control.svg";
import img10 from "../../../Images/Icon/C4_WWW_Icons_White-Whole-Home.svg";
import img11 from "../../../Images/Icon/connect-white.svg";
import img12 from "../../../Images/Icon/assist-white.svg";
import { useJump } from "../../../Components/Hooks/useJumpSection";

const arr = [
  { title: "smart home os", image: img },
  { title: "whole home", image: img10 },
  { title: "smart lighting", image: img8 },
  { title: "home security", image: img4 },
  { title: "intercom anywhere", image: img6 },
  { title: "home theater", image: img5 },
  { title: "multi-room audio", image: img7 },
  { title: "universal remote", image: img2 },
  { title: "voice control", image: img9 },
  { title: "4sight serveces", image: img3 },
  { title: "assist", image: img12 },
  { title: "connect", image: img11 },
];

const Item = styled("a")(({ theme }) => ({
  ...theme.typography.body2,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 10,
  padding: theme.spacing(1),
  width: "100%",
  textAlign: "center",
  boxShadow: "none",
  color: theme.palette.primary.dark,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
  cursor: "pointer",
  "& img": {
    transition: "all .2s",
  },
  "&:hover img": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

function ImportantSection() {
  const { targetRef } = useJump();

  const handleScroll = () => {
    if (targetRef.current) {
      animate(window.scrollY, targetRef.current.offsetTop, {
        duration: 1.5,
        ease: "easeInOut",

        onUpdate: (latest) => window.scrollTo(0, latest),
      });
    }
  };

  return (
    <div className="bg-[#f6f6f7] py-20">
      <Container
        sx={{
          maxWidth: { lg: "1024px", xl: "1280px" },
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <Typography
          variant="h4"
          textTransform="uppercase"
          fontWeight={300}
          fontSize={{ xs: 24, sm: 28, md: 34 }}
        >
          What's most important <br /> To <b>you</b>?
        </Typography>
        <Typography fontSize={17}>
          We have the products that give you full control of nearly everything
          at home—no matter where you may be.
        </Typography>
        <Stack
          direction="row"
          flexWrap={{ xs: "wrap", lg: "nowrap" }}
          spacing={{ lg: 0, xl: 1 }}
        >
          {arr.map((item, index) => {
            return (
              <Item
                key={item.title + index}
                // href="#"
                onClick={handleScroll}
                sx={{
                  width: "33.33333%",
                  textTransform: "uppercase",
                  fontSize: 11.5,
                  fontWeight: 500,
                }}
              >
                <img
                  src={item.image}
                  className="w-[100px] bg-[#939598] rounded-full"
                  alt=""
                />
                {item.title}
              </Item>
            );
          })}
        </Stack>
      </Container>
    </div>
  );
}

export default ImportantSection;
